// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root__tAaOQ","modal":"Modal_modal__3qq8S"};